<!--  -->
<template>
  <div 
    class="card"
  >
      <!-- <img 
        class="card__img" 
        src="@/assets/subImg.png"
        @click="handleClick"
      /> -->
      <!-- {{currentInfo}} -->
      <div class="operation">
        <div class="card__btn">
          <!-- 发题 -->
          <template v-if="checkShowAllowEnter()">
            <button 
              :style="genStyle()"
              @click="handleClick" 
              :disabled='!checkShowAllowEnter()' 
              class="card__btn__content"
            >
            {{info.bundleName}}
            </button>
          </template>
          <!-- 未发题 -->
          <template v-else>
            <!-- 设置收发题 -->
            <template v-if="checkShowCountDown()">
              <button 
                :style="genStyle()"
                v-if="!isShowCountDown"
                @click="handleClick" 
                :disabled='!currentInfo.published' 
                class="card__btn__content"
                >
                {{info.bundleName}}
              </button>
              <div v-show="isShowCountDown" class="card__btn count_down">
                <CountDown
                  tipText='距离发题'
                  :isShowCountDown.sync='isShowCountDown'
                  :timeDistance='currentInfo.remainingTime'
                  :isClear='isClearTimer'
                  @countOver='countOver'
                />
              </div>
            </template>
            <!-- 没有设置收发题 -->
            <template v-else>
              <button 
                :style="genStyle()"
                @click="handleClick" 
                :disabled='false' 
                class="card__btn__content"
                >
                {{info.bundleName}}
              </button>
              <div 
                @click="refresh('btn')" 
                :class="['refresh_btn',{'isRefresh':isRefresh}]" 
                :style="setStyle()">
                <img src="@/assets/refresh.png" width="20" height="20" alt="">
              </div>
            </template>
          </template>
        </div>
      </div>
      
      <!-- <p 
        :style="genStyle()" 
        class="card__text"
        @click="handleClick"
      >{{info.bundleName}}</p> -->
      <xh-dialog
        title="提示"
        :visible.sync="dialogVisible"
        width="500px"
        center
      >
        <span>您确定开始作答吗？</span>
        <span slot="footer" class="dialog-footer">
          <button @click='dialogVisible = false'>取消</button>
          <button @click='handleEnsure'>确定</button>
        </span>
      </xh-dialog>
      <Agreement
        v-show="showAgreement"
        :timingType='info.timingType'
        @close="onAgreementClose"
        @onSuccess='onSuccessAgreement'
      ></Agreement>
    <DiagnoseModel
      :showDiagnose="showDiagnose"
      @startDiagnose="startDiagnose"
      :diagnoseDetail="diagnoseDetail"
      @closeDiagnose="showDiagnose=false"
    />
  </div>
</template>

<script>
import { mapGetters,mapState,mapActions } from 'vuex';
import { getDiagnoseDetail } from '@/services/login';
import {
  getStuFirstTime,
  readCompetition,
  getQuestionGroupState
} from '@/services/student';
import Agreement from './Agreement';
import CountDown from '@/components/CountDown1.vue';
import DiagnoseModel from '@/components/DiagnoseModel.vue';
import loading from '@/utils/loading';
import { errorHandler } from '@/utils/errorHandler';
export default {
  props: {
    info: {
      type: Object,
      default: (() => {})
    },
    moduleId: {
      type: [String, Number],
      default: null
    },
    globalConfig:{
      type: Object,
      default: (() => {})
    }
  },
  components:{
    Agreement,
    CountDown,
    DiagnoseModel,
  },
  data () {
    return {
      diagnoseDetail: {},
      showDiagnose:false,
      dialogVisible:false,
      showAgreement:false,
      timer:null,
      isRefresh:false,
      isShowCountDown:false,
      currentInfo:this.info,
      requsetTimer:null, //轮训查看状态
      requsetState:0, //-1：已收题，0-即将发题，1-已发题
      isClearTimer:false
    }
  },
  watch:{
    info:{
      handler(newVal){
        this.currentInfo = {...newVal}
      },
      deep:true
    },
    $route:{
      handler(){
        this.isClearTimer = true;
        this.showDiagnose = false;
      },
      // 深度观察监听
      deep: true
    }
  },
  methods:{
    ...mapActions(['setRefresh']),
    countOver(){
      this.currentInfo.published = true;
    },
    refresh(type){
      this.isRefresh = true;
      this.setRefresh({type,flag:true})
      if(this.timer) clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        // window.postMessage({ type: 'getModuleList',refresh:true})
        this.setRefresh({type,flag:false})
        this.timer = null;
        this.isRefresh = false;
      },500);
    },
    handleClick(){
      const { published, everUnPublished } = this.currentInfo
      if (!this.loginStatus) return this.$message.showMessage({info: '请您登陆后再试'});
      if (!published) return this.$message.showMessage({info: '暂未发题'});
      if(this.requsetTimer){
        clearInterval(this.requsetTimer)
        this.requsetTimer = null;
      }
      if(!everUnPublished && !this.requsetTimer && this.requsetState === 0) {
        // loading.show();
        this.requsetTimer = setInterval(() => {
          this.getPublishState()
        }, 500);
        return;
      }
      loading.hide();
      if(Number(this.compType) === 3) {
        if(!this.showDiagnose && this.info.agreePopup) {
          this.getDiagnoseDetail();
          this.showDiagnose = !this.showDiagnose;
        } else {
          if (!this.info.timingType) {
            this.$emit('handleClick',this.info);
          }else {
            this.handleEnsure()
          }
        }
      } else {
        if(!this.showAgreement && this.info.agreePopup) {
          this.showAgreement = !this.showAgreement;
        }else{
          if (!this.info.timingType) {
            this.$emit('handleClick',this.info);
          }else {
            this.handleEnsure()
          }
        }
      }
      // if (!this.info.timingType) {
      //   this.$emit('handleClick',this.info.bundleId);
      // }else {
      //   this.dialogVisible = true;
      // }
    },
    async getPublishState(){
      try {
        let {data} = await getQuestionGroupState({bundleId:this.info.bundleId})
        this.requsetState = data;
        if(this.requsetState !== 0) this.handleClick()
      } catch (error) {
        if(this.requsetTimer){
          clearInterval(this.requsetTimer)
          this.requsetTimer = null;
        }
        errorHandler(error)
      }
     
    },
    async getDiagnoseDetail() {
      try {
        const { moduleId, info } = this;
        const { bundleId } = info;
        const { data } = await getDiagnoseDetail({moduleId, bundleId})
        if(data) this.diagnoseDetail = data
      } catch (error) {
        errorHandler(error)
      }
    },
    startDiagnose() {
      this.onSuccessAgreement(false, true);
    },
    onSuccessAgreement(val, isFromDiagnose){
      readCompetition({ bundleId:this.info.bundleId,competitionId: this.id})
        .then(res=>{
          if(res.status === 200){
            if(!isFromDiagnose) this.showAgreement = val;
            if (!this.info.timingType) {
              this.$emit('handleClick',this.info);
            }else {
             this.handleEnsure()
            }
          }
        })
    },
    onAgreementClose(val){
      this.showAgreement = val;
    },
    handleEnsure() {
      getStuFirstTime({ bundleId:this.info.bundleId })
        .then(() => {
            this.$emit('handleClick',this.info);
        })        
        .catch(( data ) => {
          errorHandler(data)
        });

    },
    setStyle(){
      return{
        'background-color':this.globalConfig.vice,
        'color':this.globalConfig.main
      }
    },
    genStyle() {
      if(this.loginStatus && this.checkShowAllowEnter()){
        return{
          'background-color':this.globalConfig.vice,
          'color':this.globalConfig.main
        }
      }
      // 诊断 && 已登录 && 已发题
      if(+this.compType === 3 && this.loginStatus && this.currentInfo.published){
        return{
          'background-color':this.globalConfig.vice,
          'color':this.globalConfig.main
        }
      }
    },
    checkShowAllowEnter() {
      // 1.未发起竞赛且未提交过不允许
      if (this.currentInfo.published && !this.currentInfo.everUnPublished) {
        return true
      }

      // 2.已收题且不允许二次进入
      if (this.currentInfo.published && this.currentInfo.everUnPublished && this.currentInfo.allowEnterAgain === 1) {
        return true
      }

      return false
    },
    checkShowCountDown() {
      if (!this.currentInfo.everUnPublished && this.currentInfo.publishTiming && this.currentInfo.remainingTime) {
        return true
      }

      return false
    }
  },
  computed: {  
    ...mapGetters([
        'loginStatus'
    ]),
    ...mapState({
      id: state => state.router.id,
      compType:state => state.router.compType,
    }),
    // this.currentInfo.published() {
    //   return this.info.published
    // }
  },
  beforeDestroy() {
    if(this.timer) clearTimeout(this.timer)
    this.timer = null;
    if(this.requsetTimer) clearInterval(this.requsetTimer)
    this.requsetTimer = null;
  },
  async mounted(){
    document.addEventListener('visibilitychange',()=>{
      if(document.visibilityState=='visible'){
        if(!this.currentInfo.published && this.currentInfo.publishTiming && this.currentInfo.remainingTime){
          this.refresh('tab')
        }  
      }
    });
  },
}

</script>
<style lang='less' scoped>
  @keyframes move {
    from{
        transform-origin:center;
        top:50%;
        transform: translate(0,-50%) rotate(0deg) ;
    }
    to{
        top:50%;
        transform-origin:center ;
        transform:translate(0,-50%) rotate(360deg) ;
    }
  }
.card {
  cursor: pointer;
  &__img {
    display: block;
    width:267px;
    height:267px;
    background:rgba(255,255,255,1);
    border-radius:8px 8px 0px 0px;
  }
  .operation{
    display: flex;
    align-items: center;
    position: relative;
  }
  &__btn{
    height: 52px;
    line-height: 50px;
    border-radius: 26px;
    color:#fff;
    border:none;
    font-size:22px;
    font-weight: 500;
    outline: none;
    cursor: pointer;
    box-sizing: border-box;
    text-align: center;
    &__content{
      min-width: 256px;
      height: 100%;
      padding:0 45px;
      background: none;
      border:none;
      border-radius: 26px;
      font-size: 22px;
      cursor: pointer;
      outline: none;
      background: #B0B0B0;
    }
    &.count_down{
      width: 257px;
      height: 100%;
      background: #B0B0B0;
      .count_down_text{
        margin-right:4px;
      }
    }
  }
  .refresh_btn{
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin-left:12px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition:all .4s ease;
    position: absolute;
    top:50%;
    transform: translate(0,-50%);
    right:-52px;
    &.isRefresh{
      animation:move 0.4s;
      animation-fill-mode:forwards;
    }
  }
  &__text {
    margin: 0;
    width:267px;
    max-height: 65px;
    height: 40px;
    letter-spacing: 1px;
    font-size:15px;
    font-family:PingFang SC;
    overflow: hidden;
    line-height: 40px;
    font-size:18px;
    border-radius:0px 0px 8px 8px;
  }
}
.dialog-footer {
  button {
      width:100px;
      height:30px;
      font-size:15px;
      font-weight:600;
      line-height:21px;
      border-radius:20px;
      cursor: pointer;
  }
  button:first-child {
    border: 2px solid rgba(159,159,159,1);
    background-color: #bebebe;
    color:rgba(255,255,255,1);
    margin-right: 60px;
  }
  button:nth-child(2) {
    color: #6B4C2E;
    border: 2px solid #f1c009;
    background-color: #fbcd1f;
  }
}
</style>